import { isShowEvent } from '../event/utils';
import logo from '../assets/Logo.png';
import logoEvent from '../assets/LogoEvent.webp';

export const Logo = ({ className, onClick }: { className?: string; onClick?: () => void }) => {
  return isShowEvent('LOGO') ? (
    <img src={logoEvent} className={className} onClick={onClick} alt="logo" />
  ) : (
    <img src={logo} className={className} onClick={onClick} alt="logo" />
  );
};
